// extracted by mini-css-extract-plugin
export default {"h2":"Pr6Fyc","h3":"jjIGHR","h4":"ZBOaS9","label":"ECWmHG"};